import {CustomFieldDefDataType, customFieldDefDataTypes} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<CustomFieldDefDataType>

export const CustomFieldDefDataTypeSelect = (props: Props) => {
  const {options = customFieldDefDataTypes, ...rest} = props;

  return <BaseDbCodeSelect options={options} {...rest} />;
};
